export default {
    roleBaseData: 'Daten',
    roleAbilities: 'Berechtigungen'
}